import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../../setup/store/store';
import { AppointmentDropInPosition } from '../models/appointment-drop-in-position.model';

const appointmentDropInPositionAdapter = createEntityAdapter({
    // easier to use appointmentId other the dropin id
    selectId: (model: AppointmentDropInPosition) => model.appointmentId,
});

const initialState = appointmentDropInPositionAdapter.getInitialState();

export const appointmentDropInPositionSlice = createSlice({
    initialState,
    name: 'appointmentDropInPositions',
    reducers: {
        // drop-in positions
        appointmentDropInPositionSetOne: appointmentDropInPositionAdapter.setOne,
        appointmentDropInPositionSetMany: appointmentDropInPositionAdapter.setMany,
        appointmentDropInPositionRemoveOne: appointmentDropInPositionAdapter.removeOne,
    },
});

export const appointmentDropInPositionSelectors
    = appointmentDropInPositionAdapter.getSelectors<RootState>(
        state => state.appointmentDropInPositions,
    );
